import React from "react";
import { ArrowForward } from "@mui/icons-material";

import OutlinedButton from "@common/OutlinedButton";
import { isDark } from "@common/utils/colors";

const NextButton = ({ onClickFn, ...props }) => {
  return (
    <OutlinedButton variant="outlined" endIcon={<ArrowForward />} onClick={onClickFn} size="small" {...props}>
      Next
    </OutlinedButton>
  );
};

export default NextButton;
